export default {
  id: 'r4k.desiredGateway.installed',
  name: 'desiredGateway.installed',
  displayName: 'Installed',
  valueType: 'boolean',
  objectType: 'desiredGateway',
  get: obj => {
    return obj?.data?.gateway?.id != null;
  }
};